export const newMailAction = "jab";
export const newNoteAction = "kab";
export default {newMailAction,newNoteAction};